import TextField from 'ui/elements/form/TextField';
import React, { useEffect } from 'react';

import ConfirmDialog from 'ui/modules/dialogs/ConfirmDialog';
import Button from 'ui/elements/buttons/Button';
import config from 'config';
import { EmbeddedUpdate } from './UpdateBlot';

export default function PostDialog({
  isOpen,
  closeDialog,
  onConfirm,
}: {
  isOpen: boolean;
  closeDialog: () => void;
  onConfirm: (update: EmbeddedUpdate) => void;
}) {
  const [url, setUrl] = React.useState<string>('');
  const [isCompany, setCompany] = React.useState<boolean>(true);
  const [slug, setSlug] = React.useState<string>('');
  const [updateId, setUpdateId] = React.useState<string>('');

  useEffect(() => {
    if (!url) {
      return;
    }

    const parsedSlug = url.match(/\/companies\/([\w-]+)/)?.[1] || '' || url.match(/\/communities\/([\w-]+)/)?.[1] || '';
    const parsedUpdateId = url.match(/\/updates\/([\w-]+)/)?.[1] || '';
    const parsedIsCompany = url.includes('/companies/');
    setSlug(parsedSlug);
    setUpdateId(parsedUpdateId);
    setCompany(parsedIsCompany);
  }, [url]);

  return (
    <ConfirmDialog
      maxWidth="sm"
      title="Embed post"
      isOpen={isOpen}
      onClose={closeDialog}
      dismissLabel="Cancel"
      confirmButton={
        <Button
          kind="primary"
          onClick={() => onConfirm({ updateId, location: { type: isCompany ? 'company' : 'community', slug: slug } })}
        >
          Insert
        </Button>
      }
    >
      <p className="u-content-spacing-bottom">Add the url of the post you would like to embed.</p>

      <TextField
        className="u-half-spacing-bottom"
        fullWidth
        value={url}
        onChange={e => setUrl(e.target.value)}
        autoFocus
        placeholder={`${config.PORTAL_URL}/companies/<company-name>/updates/<update-id>`}
      />
    </ConfirmDialog>
  );
}
